// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2363 ? "premiumcarousel.b422bc86" : chunkId) + "--" + {"1751":"04ef40c","2025":"c76f542","2363":"e6a680d","9202":"bdcbcdc"}[chunkId] + ".css";
};